import React from 'react';
import { IonCardHeader, IonCardTitle, IonCardContent, IonSkeletonText } from '@ionic/react';

type Props = {
  title: string,
};

const SkeletonComponent: React.FC<Props> = ({ title }) => {
  return (
    <div>
      <IonCardHeader>
        <IonCardTitle>{title}</IonCardTitle>
        <IonSkeletonText animated style={{ width: '60%', height: '30px' }} />
      </IonCardHeader>
      <IonCardContent>
        <IonSkeletonText animated style={{ width: '60%' }} />
        <IonSkeletonText animated />
        <IonSkeletonText animated style={{ width: '88%' }} />
        <IonSkeletonText animated style={{ width: '70%' }} />
        <IonSkeletonText animated style={{ width: '60%' }} />
      </IonCardContent>
    </div>
  )
  
};

export default SkeletonComponent;